import { Injectable } from '@angular/core';
import { HttpClient,HttpParams,HttpHeaders } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class AccountFilterService {

  accountFilter$: BehaviorSubject<any>;
  accountResults$: BehaviorSubject<any>;
  lastAccounts$: BehaviorSubject<Object>;
  allAccountFilters$: BehaviorSubject<any>;

  constructor(private http: HttpClient,
    private snackBar: MatSnackBar) {
    this.accountFilter$ = new BehaviorSubject(null);
    this.accountResults$ = new BehaviorSubject(null);
    this.lastAccounts$ = new BehaviorSubject(null);
    this.allAccountFilters$ = new BehaviorSubject(null);
   }

  loadAccountsFiltering(filter) {
    this.accountFilter$.next({"loading":true,data:[]});
    let params = new HttpParams().set('filter', filter);
    this.http.get("/api/data/accountsfilters", { params }).subscribe(
      (response: any) => {
        const rtn = response;
        this.accountFilter$.next({"loading":false, "type":filter, data:rtn});
      }, (error: any) => {
        console.log('unable to get Filtering: ' + filter);
        console.log(error);
      }
    );
  }

  loadAccountsdashboard(data:object) {
    this.accountResults$.next({"loading":true, data:[]});

    let body = new HttpParams();
    Object.keys(data).forEach(x => {
      body = body.append(x,data[x]);
    })
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    this.http.post("/api/data/accountsdashboard", body.toString(), {headers: headers})
    .subscribe(
      (response: any) => {
        if(response.success){
          const rtn = response;
          this.accountResults$.next({"loading":false, data:rtn});
        }
      }, (error: any) => {
        let message="Unable to Search Accounts"
        let snackBarRef = this.snackBar.open(message, "", { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
        console.log(message + " > " + JSON.stringify(error));

        // setTimeout(() => {
        //   document.location.reload();
        // },1000)
      }
    );
  }

  getLastAccounts() {
    this.lastAccounts$.next({ loading: true, data: [] });
    this.http.get('/api/data/lastaccounts').subscribe(
      (response: any) => {
        const rtn = response;
        this.lastAccounts$.next({ loading: false, data: rtn });
      }, (error: any) => {
        console.log('unable to get recently visited accounts');
        console.log(error);
      }
    );
  }

  loadAllAccountsFiltering() {
    this.allAccountFilters$.next({ loading: true, data: [] });
    this.http.get('/api/data/accountsfilters').subscribe(
      (response: any) => {
        const rtn = response;
        this.allAccountFilters$.next({ loading: false, data: rtn });
      }, (error: any) => {
        console.log('Unable to get filtering');
        console.log(error);
      }
    );
  }
}
